import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MenuBadgeService } from '../modules/finance-work/services/menu-badge.service';

/**
 * ปิดงานแล้วตัวเลขข้างเมนูลดทันที (user แจ้ง 15 ก.ย. 2569)
 *
 * เดิมตัวเลขรีเฟรชทุก 3 นาทีอย่างเดียว → ต้องกด refresh ทั้งหน้าถึงจะเห็นเลขใหม่
 * ที่นี่ดักทุกคำสั่ง "เขียน" (POST/PUT/PATCH/DELETE) ที่สำเร็จแล้วสั่งนับใหม่ให้เอง
 * — ไม่ต้องไล่แก้ทีละหน้า และหน้าใหม่ในอนาคตก็ได้ผลนี้ฟรี
 *
 * กันยิงวน: ข้าม endpoint ของตัวนับเอง · การรวบคำขอ (auditTime 800ms) อยู่ใน MenuBadgeService
 * ใช้ Injector แบบ lazy เพราะ MenuBadgeService ใช้ HttpClient — ฉีดตรง ๆ จะวน DI
 */
@Injectable()
export class BadgeRefreshInterceptor implements HttpInterceptor {
    constructor(private injector: Injector) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const isWrite = req.method !== 'GET' && req.method !== 'HEAD' && req.method !== 'OPTIONS';
        const isFinance = req.url.includes('/finance/');
        const isBadgeItself = req.url.includes(MenuBadgeService.ENDPOINT);

        if (!isWrite || !isFinance || isBadgeItself) {
            return next.handle(req);
        }

        return next.handle(req).pipe(
            tap((event) => {
                if (event instanceof HttpResponse && event.status >= 200 && event.status < 300) {
                    this.injector.get(MenuBadgeService).refresh();
                }
            })
        );
    }
}
